import updateCart from './updateCart';
// import updateCartQuantity from './updateCartQuantity';
// import { algoliaConversionEvent, algoliaSearchConversionEvent } from '../../components/algolia/events';

export default ($form, redirect = '') => {
  return new Promise((resolve, reject) => {
    $('[data-add-to-cart-error]').removeClass('active');
    const edit_mode = $('body').hasClass('edit-cart');

    let add_data = $form;
    if (typeof $form !== 'string') {
      add_data = $form.serialize();
    }

    /*
    const json_add_data = JSON.stringify($form.serializeArray());
    const product_id_obj = _.find(json_add_data, { name: 'id' });
    const product_id = (typeof product_id === 'undefined') ? 0 : product_id_obj.value;
    console.log('Added to cart - ', add_data, product_id);
    */

    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: add_data,
      success: () => {
        if (redirect.length) {
          window.location.href = redirect;
          resolve(true);
          return;
        }

        if (edit_mode) {
          window.location.reload(false);
          resolve(true);
          return;
        }

// console.log('... 1');
        // quicklook-modal can be on any page (search overlay)
        if ($('#quicklook-modal').is(':visible')) {
          // if ($('body').hasClass('has-overlay-search')) {
          //   algoliaSearchConversionEvent([window.sessionStorage.getItem('algolia-pid-qv')], 'QV');
          // } else {
          //   algoliaConversionEvent([window.sessionStorage.getItem('algolia-pid-qv')], 'QV');
          // }

          $('#quicklook-modal [data-quickview-add-to-cart-available]').text(window.theme.strings.addedToCart);
          
          window.setTimeout(() => {
            $('#quicklook-modal [data-quickview-add-to-cart-available]').text(window.theme.strings.addToCart);
          }, 800);

          window.setTimeout(() => {
            updateCart(null, null, true);
          }, 1000);

          resolve(true);
          return;
        }
// console.log('... 2');
        // quicklook-modal-mobile can be on any page (search overlay)
        if ($('#quicklook-modal-mobile').hasClass('active')) {
          // Add Algolia Event
          // if (window.sessionStorage.getItem('algolia-pid-qv') !== null) {
          //   if ($('body').hasClass('has-overlay-search')) {
          //     algoliaSearchConversionEvent([window.sessionStorage.getItem('algolia-pid-qv')], 'QV');
          //   } else {
          //     algoliaConversionEvent([window.sessionStorage.getItem('algolia-pid-qv')], 'QV');
          //   }
          // }

          $('#quicklook-modal-mobile [data-quickview-add-to-cart-available]').text(window.theme.strings.addedToCart);
          
          window.setTimeout(() => {
            $('#quicklook-modal-mobile [data-quickview-add-to-cart-available]').text(window.theme.strings.addToCart);
          }, 800);

          window.setTimeout(() => {
            updateCart(null, null, true);
          }, 1000);

          resolve(true);
          return;
        }
// console.log('... 3');
        // Remove the old product from the cart if it's an "edit"
        /*
        if ($('.template-cart').length) {
          const remove_variant_id = $('[data-cart-edit].active').closest('[data-cart-item]').data('variant-id');
          const updates = {};
          updates[remove_variant_id] = 0;
          updateCartQuantity(updates);
          resolve(true);
          return;
        }
        */
// console.log('... 4');
        // Mobile sticky add to cart on PDP
        if ($('.mobile-sticky-add-to-cart-opened-colors').length > 0) {
          // Add Algolia Event
          // if (window.sessionStorage.getItem('algolia-pid') !== null) {
          //   algoliaConversionEvent([window.sessionStorage.getItem('algolia-pid')], 'PDP');
          // }
          
          $('[data-mobile-sticky-add-to-cart-main] [data-add-to-cart-available]').text(window.theme.strings.addedToCart);
          
          window.setTimeout(() => {
            $('[data-mobile-sticky-add-to-cart-main] [data-add-to-cart-available]').text(window.theme.strings.addToCart);
          }, 800);

          // Mobile sticky add to cart closes after 1000ms

          window.setTimeout(() => {
            updateCart(null, null, true);
          }, 1500);

          resolve(true);
          return;
        }
// console.log('... 5');
        // Delay slideout cart opening and CTA updates
        if ($('.template-product').length && !$('[data-overlay-search]').hasClass('opened')) {
          // Add Algolia Event
          // if (window.sessionStorage.getItem('algolia-pid') !== null) {
          //   algoliaConversionEvent([window.sessionStorage.getItem('algolia-pid')], 'PDP');
          // }

          $('[data-product-overview] [data-add-to-cart-available]').text(window.theme.strings.addedToCart);
          $('[data-desktop-sticky-add-to-cart-main] [data-add-to-cart-available]').text(window.theme.strings.addedToCart);

          window.setTimeout(() => {
            $('[data-product-overview] [data-add-to-cart-available]').text(window.theme.strings.addToCart);
            $('[data-desktop-sticky-add-to-cart-main] [data-add-to-cart-available]').text(window.theme.strings.addToCart);
          }, 800);

          window.setTimeout(() => {
            updateCart(null, null, true);
          }, 1000);

          resolve(true);
          return;
        }
// console.log('... 6');
        updateCart(null, null, true);

        resolve(true);
        // console.log('item added to cart', add_data);
      },
      error: (XHR) => {
        console.log(XHR);

        if (typeof XHR.responseJSON !== 'undefined') {
          $('[data-add-to-cart-error]').html(XHR.responseJSON.description).addClass('active');
        }

        resolve(false);
      },
    });
  });
};
